import React from "react";

const Faq = () => {
  return (
    <>
      {/*FAQ*/}
      <section className="faq-section">
        <h3 className="title-head text-center ">
          FAQ{" "}
          <strong style={{ color: "#f7b205" }}>
            (Frequently Asked Questions)
          </strong>
        </h3>
        <div className="container">
          <div className="faq" id="accordion">

          <div className="card">
              <div className="card-header" id="faqHeading-5">
                <div className="mb-0">
                  <h5
                    className="faq-title"
                    data-toggle="collapse"
                    data-target="#faqCollapse-5"
                    data-aria-expanded="false"
                    data-aria-controls="faqCollapse-5"
                  >
                    <span className="badge">1</span> What is TopFaculty?
                  </h5>
                </div>
              </div>
              <div
                id="faqCollapse-5"
                className="collapse"
                aria-labelledby="faqHeading-5"
                data-parent="#accordion"
              >
                <div className="card-body">
                  <p>
                    <span>
                      Ans:- TopFaculty is an educational platform that connects
                      students with qualified teachers and coaching institutes.
                      It offers various services, including online classes,
                      recorded video lectures, live sessions, home tuition, and
                      access to expert faculties across different subjects and
                      competitive exams.
                    </span>
                  </p>
                </div>
              </div>
            </div>



            <div className="card">
              <div className="card-header" id="faqHeading-1">
                <div className="mb-0">
                  <h5
                    className="faq-title"
                    data-toggle="collapse"
                    data-target="#faqCollapse-1"
                    data-aria-expanded="true"
                    data-aria-controls="faqCollapse-1"
                  >
                    <span className="badge">2</span> Is there a free trial class
                    available?
                  </h5>
                </div>
              </div>
              <div
                id="faqCollapse-1"
                className="collapse"
                aria-labelledby="faqHeading-1"
                data-parent="#accordion"
              >
                <div className="card-body">
                  <p>
                    <span style={{ color: "black", fontSize: 21 }}>Ans:-</span>
                    “Yes. TopFaculty offers a free demo class. Additionally, the
                    first two trial sessions come with 7 days of full access to
                    the platform. ”{" "}
                  </p>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header" id="faqHeading-2">
                <div className="mb-0">
                  <h5
                    className="faq-title"
                    data-toggle="collapse"
                    data-target="#faqCollapse-2"
                    data-aria-expanded="false"
                    data-aria-controls="faqCollapse-2"
                  >
                    <span className="badge">3</span> What types of classes are
                    available?
                  </h5>
                </div>
              </div>
              <div
                id="faqCollapse-2"
                className="collapse"
                aria-labelledby="faqHeading-2"
                data-parent="#accordion"
              >
                <div className="card-body">
                  <p>
                    <span style={{ color: "black", fontSize: 21 }}>Ans:-</span>{" "}
                    <ol>
                      <li>Online Classes</li>
                      <li>Recorded Video Lectures</li>
                      <li>Live Classes</li>
                      <li>Home Tuition</li>
                    </ol>{" "}
                  </p>
                </div>
              </div>
            </div>

            <div className="card">
              <div className="card-header" id="faqHeading-4">
                <div className="mb-0">
                  <h5
                    className="faq-title"
                    data-toggle="collapse"
                    data-target="#faqCollapse-4"
                    data-aria-expanded="false"
                    data-aria-controls="faqCollapse-4"
                  >
                    <span className="badge">4</span> What All Facilities
                    Available?
                  </h5>
                </div>
              </div>
              <div
                id="faqCollapse-4"
                className="collapse"
                aria-labelledby="faqHeading-4"
                data-parent="#accordion"
              >
                <div className="card-body">
                  <ul>
                    <li>
                      ✅ <strong>Smart Classrooms</strong> – Air-conditioned
                      classrooms with projector-based teaching.
                    </li>
                    <li>
                      📚 <strong>Library &amp; Reading Room</strong> – Quiet,
                      well-stocked library with daily newspapers, magazines, and
                      reference materials.
                    </li>
                    <li>
                      💻 <strong>Wi-Fi &amp; Digital Lab</strong> – High-speed
                      internet and systems for online test series and current
                      affairs updates.
                    </li>
                    <li>
                      🧑‍🏫 <strong>Expert Faculty Access</strong> – Regular
                      doubt-clearing sessions and 1-on-1 mentorship with
                      experienced faculty.
                    </li>
                    <li>
                      📝 <strong>Daily Practice Tests</strong> – Prelims and
                      Mains test series with in-depth analysis and feedback.
                    </li>
                    <li>
                      🛏️ <strong>Hostel Facility</strong> – Separate boys and
                      girls hostels with 24/7 security and study environment.
                    </li>
                    <li>
                      🔒 <strong>Secure Campus</strong> – CCTV surveillance,
                      biometric entry, and disciplined study environment.
                    </li>
                  </ul>
                </div>
              </div>
            </div>

           
            <div className="card">
              <div className="card-header" id="faqHeading-6">
                <div className="mb-0">
                  <h5
                    className="faq-title"
                    data-toggle="collapse"
                    data-target="#faqCollapse-6"
                    data-aria-expanded="false"
                    data-aria-controls="faqCollapse-6"
                  >
                    <span className="badge">5</span> How can I contact
                    TopFaculty for support?
                  </h5>
                </div>
              </div>
              <div
                id="faqCollapse-6"
                className="collapse"
                aria-labelledby="faqHeading-6"
                data-parent="#accordion"
              >
                <div className="card-body">
                  <p>
                    <span>
                      Ans:- For any queries or support, you can reach out to
                      TopFaculty via: 
                     
                    </span>
                    <ul>
                    <li>
                      ✅ <strong>Email:</strong> –topfauclty01@gmail.com</li>
                      <li>
                      ✅ <strong>Phone:</strong> – 011-45623333 or +91 9990963333
                    </li>
                    </ul>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Faq;
